import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createFloorMapApi,
  getFloorMapsApi,
  deleteFloorMapApi,
  updateFloorMapApi,
} from "./floorMapApi";

// GET
export const getFloorMaps = createAsyncThunk(
  "floorMap/get",
  async (params, thunkAPI) => {
    try {
      const res = await getFloorMapsApi(params);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

// CREATE
export const createFloorMap = createAsyncThunk(
  "floorMap/create",
  async (data, thunkAPI) => {
    try {
      const res = await createFloorMapApi(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

// DELETE
export const deleteFloorMap = createAsyncThunk(
  "floorMap/delete",
  async (id, thunkAPI) => {
    try {
      await deleteFloorMapApi(id);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

// UPDATE
export const updateFloorMap = createAsyncThunk(
  "floorMap/update",
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await updateFloorMapApi(id, data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

const floorMapSlice = createSlice({
  name: "floorMap",
  initialState: {
    floorMaps: [],
    total: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getFloorMaps.pending, (state) => {
        state.loading = true;
      })

      .addCase(getFloorMaps.fulfilled, (state, action) => {
        state.loading = false;
        state.floorMaps = action.payload.items || [];
        state.total = action.payload.total || 0;
      })

      .addCase(getFloorMaps.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteFloorMap.fulfilled, (state, action) => {
        state.floorMaps = state.floorMaps.filter(
          (f) => f.id !== action.payload
        );
      });
  },
});

export default floorMapSlice.reducer;